import { ActionType, getType } from 'typesafe-actions';
import { RequestState } from '../../constants/request-state';
import { EntityMapState } from '../../types/state/entities/EntityMapState';
import { Company } from '../../types/amr-pipeline/models/Company';
import { debtInvestorsActions } from '../../actions/entities/debtInvestors.action';
import { apiUtils } from '../../utils';

export const debtInvestorsDefaultState: EntityMapState<string, Company> = {
    items: {},
    requestState: RequestState.none,
};

export type DebtInvestorsActionTypes = ActionType<
    | typeof debtInvestorsActions.requestDebtInvestors
    | typeof debtInvestorsActions.responseDebtInvestors
>;

export function debtInvestorsReducer(
    state = debtInvestorsDefaultState,
    action: DebtInvestorsActionTypes,
): EntityMapState<string, Company> {
    switch (action.type) {
        case getType(debtInvestorsActions.requestDebtInvestors):
            return {
                ...state,
                requestState: action.payload.requestState,
            };
        case getType(debtInvestorsActions.responseDebtInvestors):
            return {
                requestState: action.payload.requestState,
                items: apiUtils.normalize(action.payload.debtInvestors, c => c.referenceName, c => c),
            };
        default:
            return state;
    }
}
